import React, { Fragment } from 'react';
import axios from "axios";
import { toast } from "react-toastify";
import CircularProgress from "@material-ui/core/CircularProgress";
import Button from "@material-ui/core/Button";
import "../../../css/course-catelog.css";
class SampleFillinblanks extends React.Component {
    constructor(props) {
      super(props);

     // const values= [] ;
      this.state = { 
        values: props.mwaarraylist,
        assid: props.assid,
        assoffid: props.assoffid,
        isfilled : false,
         loading: false,
      };
      this.handleInputChange = this.handleInputChange.bind(this);
    }
  

    handleInputChange(mid, index, event) {
   
      const values = [...this.state.values];
      if (event.target.name === "answertext") {
        this.state.values[index].answertext = event.target.value;
        this.state.values[index].mid =mid;
      } 
      this.setState({
        values
      });
      
    }
  
    sleep(milliseconds) {
      return new Promise((resolve) => setTimeout(resolve, milliseconds));
    }
    


    handleSubmit(e, assid , assoffid) {
      e.preventDefault();
      
       this.saveFillinblanks(assid , assoffid);
    }
  
    async saveFillinblanks(assid ,  assoffid) {
      this.setState({ loading: true });
        var anscheck = false
        this.state.values.map((itemn, indexitemn) =>{
        
         if(itemn.answertext === undefined  || itemn.answertext === "" ){
          // toast.error("Please enter valid  answer");
           
          this.setState({ isfilled : true })
          anscheck =true 
          // break;
           return;
         }
         else{
          this.setState({ isfilled : false}) 
          anscheck = false
         }
        }
        );
       // return;

        if(anscheck){
          toast.error("Please enter valid  answer");
          await this.sleep(3000);
          this.setState({ loading: false });
       
          return;
        }
        var formData = new FormData();
        {
          this.state.values.map((itemn, indexitemn) =>
            // formData.append("answer", itemn.answertext),
            formData.append(itemn.mid, itemn.answertext),
          );
        }
        {
          this.state.values.map((itemn, indexitemn) =>
          
           // formData.append("mwa", itemn.mwaid),
            formData.append("mwa", itemn.mid),
      
          );
        }
       formData.append("ass",  assid );
     
       formData.append("assoffid",  assoffid );
  
      axios
        .post("LearnerAssignment/saveFillTheGapAssAnswer", formData)
  
        .then((res) => {
          if (res.data.status === "200" || res.data.status === "100") {
            toast.success(res.data.msg);
            this.setState({ loading: false });
           // window.location.reload(false);
          } else {
            toast.error("Something went wrong");
          }
        });   

      
    }
  
    render() {
     
  
      return (
        <div>
            {this.state.values.map((item, indexitem) => (
              <>
                 <Fragment key={`${this.state.values}~${indexitem}`}>
              <div className="form-group col-sm-6">
               
                <input
                  type="text"
                  className="form-control"
                  id="answertext"
                  name="answertext"
                   value={item.answertext}
                  onChange={event => this.handleInputChange(item.mwaid,indexitem, event  )}
                required
               />
              </div>
             
             
            </Fragment>

              </>
              ))}
          

      

                <div className="row">
              <div className="col-lg-12 text-center">
                <Button
                  variant="contained"
                  color="primary"
                  disabled={this.state.loading}
                  onClick={(e) =>
                    this.handleSubmit(e, this.state.assid,   this.state.assoffid)
                  }
                >
                 Submit
                </Button>

                {this.state.loading === true ? (
                  <CircularProgress
                    size={24}
                    color="green"
                    className="buttonProgress1"
                  />
                ) : (
                  ""
                )}
              </div>
            </div>
                <br />
        </div>
      );
    }
  }
export default SampleFillinblanks;

//   ReactDOM.render(<App />, document.getElementById('container'));